import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {AdminService} from "../../services/admin.service";
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {MatTableModule} from "@angular/material/table";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'app-admin-server-params',
  templateUrl: './admin-server-params.component.html',
  styleUrls: ['./admin-server-params.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    AsyncPipe,
  ]
})
export class AdminServerParamsComponent implements OnInit {

  serverParams$: Observable<any[]>;
  formData: UntypedFormGroup;
  readonly columns = ['key', 'value'];

  constructor(private adminService: AdminService) {
  }

  ngOnInit(): void {
    this.serverParams$ = this.adminService.getServerParams();
    this.formData = new UntypedFormGroup({
      key: new UntypedFormControl('', [Validators.required]),
      value: new UntypedFormControl(''),
    });
  }

  setServerParam(): Promise<void> {
    const rawValue = this.formData.getRawValue();
    if (!rawValue.value) {
      return this.adminService.deleteServerParam(rawValue.key);
    }
    return this.adminService.setServerParam(rawValue.key, {key: rawValue.key, value: rawValue.value});
  }
}
